import apiUseCases from "@src/cloud-connect/api";
import { Machine } from "@src/cloud-connect/api/client-configuration/get-machine-by-id";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const getMachinesUseCase = async (): Promise<{
  success: boolean;
  data?: Machine[];
  error?: string;
}> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getMachines(namespace);

    return { success: true, data: response.machines };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch machines.").message,
    };
  }
};
